
import { COMPARE_INDEX } from '../../../lib/constants';
import {
  PrivateMeetingSessionDetailsListResponseType,
  PrivateMeetingSessionDetailsResponseType } from '../../../lib/api';
import { PrivateMeetingSessionList } from './GridLayout/index';

export interface IMeetingsByStartTime {
  meetingsList: PrivateMeetingSessionList;
  startTime: string;
  endDateTime: Date;
}

const getActiveTracks = (activeMeetings: PrivateMeetingSessionDetailsListResponseType): string[] => {
  return [...new Set(activeMeetings.map(m => m.track))].sort((t1, t2) =>
    !t1 ? COMPARE_INDEX : !t2 ? -COMPARE_INDEX : t1.localeCompare(t2)
  );
};

const int = 1;

const truncate = (str: string, n: number): string => {
  return str?.length > n ? str.substr(0, n - int) + "..." : str;
};

const getMeetingsByStartTime = (meetings: PrivateMeetingSessionDetailsResponseType[]): IMeetingsByStartTime[] => {
  const meetingsBySelectedDate = meetings;
  const startDateTimes = [...new Set(meetingsBySelectedDate.map(m => m.startDateTime))];
  return startDateTimes.map((startDateTime: string) => {
    const meetingsByStartTime = meetingsBySelectedDate.filter(m => m.startDateTime === startDateTime);
    const endDateTime = meetingsByStartTime.map(m => new Date(m.endDateTime)).reduce((ed, d) => (ed < d ? d : ed));
    return {
      meetingsList: meetingsByStartTime,
      startTime: startDateTime,
      endDateTime
    };
  });
};

const getActiveMeetings = (meetingsByStartTime: IMeetingsByStartTime[], showPastMeetings: boolean): PrivateMeetingSessionList => {
  const nowDateInMs = new Date().getTime();
  let activeMeetings: PrivateMeetingSessionList = [];
  meetingsByStartTime.forEach(ms => {
    const endDateInMs = ms.endDateTime.getTime();
    activeMeetings = !showPastMeetings && endDateInMs < nowDateInMs ? activeMeetings : activeMeetings.concat(ms.meetingsList);
  });
  return activeMeetings;
};

export {
  truncate,
  getActiveTracks,
  getActiveMeetings,
  getMeetingsByStartTime
};

